var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9583 2C14.1533 2 13.5 2.68923 13.5 3.53846V16.4615C13.5 17.3108 14.1533 18 14.9583 18H15.5417C16.3467 18 17 17.3108 17 16.4615V3.53846C17 2.68841 16.3467 2 15.5417 2H14.9583ZM8.25 7.23077C8.25 6.38072 8.90333 5.69231 9.70833 5.69231H10.2917C11.0974 5.69231 11.75 6.38154 11.75 7.23077V16.4615C11.75 17.3108 11.0967 18 10.2917 18H9.70833C9.32156 18 8.95063 17.8379 8.67714 17.5494C8.40365 17.2609 8.25 16.8696 8.25 16.4615V7.23077ZM3 10.9231C3 10.073 3.65333 9.38462 4.45833 9.38462H5.04167C5.84744 9.38462 6.5 10.0738 6.5 10.9231V16.4615C6.5 17.3108 5.84667 18 5.04167 18H4.45833C4.07156 18 3.70063 17.8379 3.42714 17.5494C3.15365 17.2609 3 16.8696 3 16.4615V10.9231Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.3b14bec991dc909882e11e4ae88a44bf.svg";
export { ForwardRef as ReactComponent };